<template>
    <Dialog
        :is-popup="isOpen"
        @close="close"
        :scrollable="false"
    >
        <div
            class="activity-change-time-popup"
             v-if="isOpen">
            <h1>Изменить дату</h1>
            <ModelISO
                class="date"
                label="Дата встречи"
                v-model="updates.date"
                @change="errors.date = false"
                :valid="!errors.date"
            />
            <ModelTime
                class="time"
                label="Время"
                v-model="updates.time"
                @change="errors.time = false"
                :valid="!errors.time"
            />
            <Button
                @click="save"
                class="btn"
            >
                Отправить
            </Button>
        </div>
    </Dialog>
</template>

<script>
import Dialog from '../../../../UI/Dialog';
import Button from '../../../../UI/Button';
import ModelISO from '../../../../UI/models/ModelISO';
import ModelTime from '../../../../UI/models/ModelTime';
import {mapActions, mapGetters, mapState} from 'vuex';
import {ActivityType} from '@/stores/mentoring/activities';
import {ActivityStatus} from '../../../../../stores/mentoring/activities';
import {validation} from '../../../../../tools/comparer';

const validators = {
    date: {
        reg: "date",
        valid: true,
    },
    time: {
        reg: "time",
        valid: true,
        validate: (v) => Array.isArray(v)
            && v.length === 2
            && v.every(v => !isNaN(parseInt(v))),
    },
};

export default {
    name: 'MeetingChangeDate',
    props: {
        activityId: {
            type: Number,
            required: false,
        },
    },
    data: () => ({
        loading: false,
        updates: {
            date: null,
            time: [null, null],
        },
        errors: {
            date: false,
            time: false,
        },
    }),
    components: {
        Dialog,
        Button,
        ModelISO,
        ModelTime,
    },
    watch: {
        activityId() {
            this.syncActivity();
        },
    },
    mounted() {
        this.syncActivity();
    },
    computed: {
        ...mapGetters('mentoring/activities', [
            'getActivity',
        ]),
        isOpen: {
            get() {
                return this.activityId != null;
            },
            set() {
                this.close();
            },
        },
    },
    methods: {
        ...mapActions('mentoring/activities', [
            'updateActivityStatus',
        ]),
        close() {
            this.$emit('close');
        },
        async save() {
            this.loading = true;
            let item = this.getActivity({ id: this.activityId, type: ActivityType.meeting });
            let datetime = item.datetime;
            let [year, month, day] = this.updates.date.split('-').map(v => parseInt(v));
            let [hours, minutes] = this.updates.time;
            datetime.setFullYear(year);
            datetime.setMonth(month - 1);
            datetime.setDate(day);
            datetime.setHours(hours);
            datetime.setMinutes(minutes);

            let errors = validation(this.updates, validators);
            if (errors.length > 0) {
                for (let key of errors) {
                    this.errors[key] = true;
                }
            } else {
                await this.updateActivityStatus({item, status: ActivityStatus.in_progress, datetime });
                this.close();
            }
            this.loading = false;
        },
        syncActivity() {
            let item = this.getActivity({ id: this.activityId, type: ActivityType.meeting });
            if (item) {
                this.setDate(item.datetime);
                this.setTime(item.datetime);
            }
        },
        setDate(date) {
            let year = date.getFullYear();
            let month = (date.getMonth() + 1).toString().padStart(2, '0');
            let day = date.getDate().toString().padStart(2, '0');
            this.updates.date = `${year}-${month}-${day}`;
        },
        setTime(date) {
            this.updates.time = date.toLocaleTimeString('ru-RU')
                .slice(0, 5)
                .split(':')
                .map(v => parseInt(v));
        },
    },
};
</script>

<style lang="scss">
    @import '../../../../../styles/rem';

    .activity-change-time-popup {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        h1 {
            font-style: normal;
            font-size: rem(24);
            line-height: rem(32);
            text-align: center;
            color: #2A2626;
            margin-top: 0;

            @include on-mobile {
                text-align: left;
                font-size: mrem(24);
                line-height: mrem(32);
            }
        }

        .time,
        .date {
            width: 100%;
        }

        .btn {
            width: rem(257);
            margin-top: rem(32);
            border-radius: rem(4);

            @include on-mobile {
                width: 100%;
                background: #4663AB;
                color: white;
                border-radius: mrem(4);
            }
        }
    }
</style>

<style lang="scss" scoped>

</style>